export const rhymeSchemePool = [
    {
      poem: "The sun is shining in the sky,\nBirds are flying way up high.",
      scheme: "AABB",
      distractors: ["ABAB", "Free Verse", "ABCABC"]
    },
    {
      poem: "Roses are red,\nViolets are blue,\nSugar is sweet,\nAnd so are you.",
      scheme: "ABCB",
      distractors: ["AABB", "ABAB", "Free Verse"]
    }
  ];
  